window.PALASIG_REVIEWS = [
 {
  "name": "Marina R.",
  "date": "Giugno 2026",
  "rating": 5.0,
  "title": "Felice",
  "body": "È molto piacevole l’applicazione del siero. Da un immediata sensazione di benessere. Dopo pochi giorni le mie amiche mi hanno detto che avevo il volto più disteso luminoso. L’ho consigliato, alle mie amiche e sorelle.Grazie",
  "img": "rec-1.jpg",
  "up": 35
 },
 {
  "name": "Flavia T.",
  "date": "Giugno 2026",
  "rating": 5.0,
  "title": "Grazie mille",
  "body": "Acquistato senza speranza...mi son dovuta ricredere....arrivato subito e di gran effetto....grazie mille eeeeeeee!!!",
  "img": "",
  "up": 26
 },
 {
  "name": "Mariagrazia C.",
  "date": "Giugno 2026",
  "rating": 5.0,
  "title": "Siero eccezionale",
  "body": "E’ un prodotto eccezionale, dopo averlo messo quotidianamente, le rughe si appianano, come se non fossero mai esistite! A breve rifarò l’ordine.",
  "img": "",
  "up": 19
 },
 {
  "name": "Roberta C.",
  "date": "Giugno 2026",
  "rating": 4.0,
  "title": "Buon siero",
  "body": "Non tanto effetto lifting ma una maggiore compattezza della pelle. Ma sono solo alla prima boccetta",
  "img": "",
  "up": 11
 },
 {
  "name": "Immacolata D.",
  "date": "Maggio 2026",
  "rating": 5.0,
  "title": "Ricomprerò",
  "body": "La mia pelle e'molto piu compatta anche se le rughe ci sono ancora credo ci vuole liu tempo sono alla fine del secondo flacone credo che ne rdinero' altri e mandero'delle foto",
  "img": "",
  "up": 27
 },
 {
  "name": "Barbara R.",
  "date": "Maggio 2026",
  "rating": 4.0,
  "title": "Bene",
  "body": "Esperienza di acquisto positiva. Conseganto abbastanza rapidamente",
  "img": "",
  "up": 7
 },
 {
  "name": "Monia A.",
  "date": "Maggio 2026",
  "rating": 5.0,
  "title": "Consigliato",
  "body": "Già con la seconda applicazione ho visto macchie e rughe attenuate!!!",
  "img": "",
  "up": 16
 },
 {
  "name": "Francesca B.",
  "date": "Maggio 2026",
  "rating": 3.0,
  "title": "Vediamo",
  "body": "Francamente secondo la vostra pubblicità mi aspettavo di più. È vero che dopo l'applicazione si sente la pelle tendersi un po' ma i solchi delle rughe persistono come prima. Eppure sto mettendo la quantità consigliata tanto e sono a metà della prima boccetta",
  "img": "",
  "up": 23
 },
 {
  "name": "Rosanna C.",
  "date": "Maggio 2026",
  "rating": 5.0,
  "title": "Fa la differenza",
  "body": "Ottimo prodotto, si sente subito la differenza sulla densità della pelle e risultati già dalla prima settimana! Lo consiglio vivamente a tutte le donne che hanno un inizio di rughette sul labbro superiore, credetemi fa la differenza da tanti sieri che ho usato in passato!",
  "img": "",
  "up": 28
 },
 {
  "name": "Iva L.",
  "date": "Maggio 2026",
  "rating": 5.0,
  "title": "Continuerò",
  "body": "Lo sto usando da una ventina di giorni e vedo un miglioramento sul mio viso sicuramente continuerò ad acquistarlo",
  "img": "rec-2.jpg",
  "up": 31
 },
 {
  "name": "Marcella D.",
  "date": "Maggio 2026",
  "rating": 4.5,
  "title": "Tutto ok",
  "body": "Lette le esperienze su Facebook, mi sono fidata...mi trovo molto bene, viso più disteso e non ho avuto allergie al prodotto. Ottima la confezione con la siringa per l'applicazione.",
  "img": "",
  "up": 12
 },
 {
  "name": "Linda L.",
  "date": "Maggio 2026",
  "rating": 3.0,
  "title": "Ancora presto forse",
  "body": "Per il momento non vedo tanta differenza",
  "img": "",
  "up": 9
 },
 {
  "name": "Chiara MF.",
  "date": "Maggio 2026",
  "rating": 5.0,
  "title": "Davvero consigliato",
  "body": "Ho aspettato a recensire il prodotto perché volevo testarlo per un pò di tempo. La pelle comincia ad essere più elastica ed avere un bel colorito. Proseguirò con il trattamento.",
  "img": "",
  "up": 17
 },
 {
  "name": "Liliana G.",
  "date": "Marzo 2026",
  "rating": 4.5,
  "title": "Lo adoro",
  "body": "Il siero Palasig rende la pelle morbida e vellutata. Lo adoro",
  "img": "rec-3.jpg",
  "up": 21
 },
 {
  "name": "Renata D.",
  "date": "Marzo 2026",
  "rating": 4.0,
  "title": "Acquisto utile",
  "body": "La pelle è liscia, ben idratata e compatta. Un acquisto veramente utile.",
  "img": "",
  "up": 13
 },
 {
  "name": "Anna R.",
  "date": "Marzo 2026",
  "rating": 5.0,
  "title": "Buono",
  "body": "Ottimo prodotto lascia la pelle morbidissima e tesa, non da fastidio nonostante la prima volta che ho sentito l'effetto sono rimasta stupita.",
  "img": "",
  "up": 8
 },
 {
  "name": "Eleonora P.",
  "date": "Febbraio 2026",
  "rating": 4.5,
  "title": "Mi ha conquistata",
  "body": "Per più di una volta ho aggiunto il siero nel carrello per acquistarlo, ma poi titubante non concludevo l’ordine.                                               Alla fine mi sono decisa a fidarmi delle recensioni e ho scelto questo specifico siero, acquistato direttamente dal sito ufficiale approfittando dello sconto 2×1.Quando finalmente è arrivato l’ho provato e devo dire che sono rimasta davvero contenta.Già dalla prima applicazione la pelle appare più distesa e compatta, con un evidente effetto lifting. Il prodotto è comodo da usare, semplice anche per me che non amo routine complicate e preferisco pochi gesti veloci e si assorbe bene senza lasciare la pelle appiccicosa. Ho dato il secondo flacone a mia mamma e anche lei è rimasta soddisfatta dell’effetto sulla pelle.",
  "img": "rec-4.jpg",
  "up": 19
 },
 {
  "name": "Paola T.",
  "date": "Febbraio 2026",
  "rating": 5.0,
  "title": "Leggero sulla pelle",
  "body": "Ho acquistato il cofanetto da tre, arrivato nei tempi giusti. Dopo averlo provato, posso dire di esserne soddisfatta. Premesso che ho una pelle ambrata, il siero non va applicato in eccesso: ne basta davvero poco. Negli ultimi tempi si trovano tanti sieri validi, ma mi sento assolutamente di consigliare questo!",
  "img": "",
  "up": 11
 },
 {
  "name": "Vania B.",
  "date": "Febbraio 2026",
  "rating": 4.5,
  "title": "Mi ha fatto cambiare idea",
  "body": "Parto dal presupposto che non sono mai stata una grande amante dei sieri.Ne ho provati tantissimi, ma nessuno mi dava soddisfazioni. E invece… credo di aver finalmente trovato quello giusto :) L’ho acquistato quasi per gioco dopo aver visto un video sui social, senza grandi aspettative. Incredibile, ma appena lo applichi la pelle cambia subito. Anche io, che non sono bravissima con le routine skincare, l’ho applicato senza problemi e il risultato si vede davvero.Lo riacquisterò sicuramente.",
  "img": "rec-5.jpg",
  "up": 5
 },
 {
  "name": "Carla F.",
  "date": "Gennaio 2026",
  "rating": 5.0,
  "title": "Bello",
  "body": "Buonissimo il siero",
  "img": "",
  "up": 0
 },
 {
  "name": "Patty V.",
  "date": "Gennaio 2026",
  "rating": 4.5,
  "title": "Inizialmente scettica",
  "body": "Ero un pochettino incredula all’inizio, ma devo dire che il prodotto si è rivelato davvero ottimo. L’effetto sulla pelle si nota subito: appare più distesa e levigata già dopo l’applicazione. L’unica cosa è che all’inizio ne avevo messo un po’ troppo: ne basta davvero una piccola quantità per ottenere il risultato migliore. Nel complesso è un ottimo prodotto e mi sento assolutamente di consigliarlo.",
  "img": "",
  "up": 8
 },
 {
  "name": "Paola R.",
  "date": "Gennaio 2026",
  "rating": 4.0,
  "title": "Mi piace",
  "body": "Bel prodotto, rende la pelle molto morbida e la sento idratata a lungo, l'effetto lifting non è miracoloso ma si vede.",
  "img": "rec-6.jpg",
  "up": 27
 },
 {
  "name": "Diana L.",
  "date": "Gennaio 2026",
  "rating": 5.0,
  "title": "Pelle fresca e giovane",
  "body": "Non è un semplice siero, ma una sorta di velo magico che si fonde con la pelle e la rende subito più distesa. Ho 50 anni e non hai mai fatto nessun trattamento per via dei costi inadeguati. E' un ottimo trattamento, per ora mi sto trovando molto bene",
  "img": "",
  "up": 14
 },
 {
  "name": "Mariachiara B.",
  "date": "Gennaio 2026",
  "rating": 4.5,
  "title": "Ottimo",
  "body": "E' un bel prodotto, mi piace",
  "img": "",
  "up": 2
 },
 {
  "name": "Rossella E.",
  "date": "Gennaio 2026",
  "rating": 4.0,
  "title": "Bel risultato",
  "body": "Nel complesso è un ottimo prodotto e sono soddisfatta dell’acquisto. L’effetto sulla pelle è naturale non aspettatevi botox",
  "img": "",
  "up": 23
 },
 {
  "name": "Maria C.",
  "date": "Gennaio 2026",
  "rating": 5.0,
  "title": "Buono",
  "body": "Buongiorno, io lo sto usando da qualche giorno, per ora tutto ok",
  "img": "",
  "up": 0
 },
 {
  "name": "Johan D.",
  "date": "June 2024",
  "rating": 5.0,
  "title": "Nice Product",
  "body": "Nice Product. I'm happy with my purchase.",
  "img": "",
  "up": 0
 },
 {
  "name": "Viviana P.",
  "date": "Gennaio 2026",
  "rating": 3.0,
  "title": "Da provare",
  "body": "Al momento sono ancora in fase di collaudo del prodotto per capire bene come funziona, ma sicuramente è valido.",
  "img": "",
  "up": 4
 },
 {
  "name": "Federica M.",
  "date": "Gennaio 2026",
  "rating": 4.0,
  "title": "Soddisfatta",
  "body": "Lo ho appena ricevuto e lo sto provando, la spedizione purtroppo in ritardo",
  "img": "",
  "up": 3
 },
 {
  "name": "Francesca D.",
  "date": "Gennaio 2026",
  "rating": 4.5,
  "title": "Molto idratante",
  "body": "Mi sento davvero idratata tutto il giorno, consigliato",
  "img": "",
  "up": 9
 }
];
